import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductReveal } from './components/ProductReveal';
import { BenefitsSection } from './components/BenefitsSection';
import { TargetAudience } from './components/TargetAudience';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-teal-500/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <ProductReveal data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />

      {/* Footer minimalista */}
      <footer className="bg-slate-950 py-8 text-center border-t border-slate-900" data-id="element-9">
        <p className="text-slate-500 text-sm" data-id="element-10">
          © {new Date().getFullYear()} Kit Ortopedista Pro. Todos los derechos
          reservados.
        </p>
      </footer>

      <SocialProofPopup data-id="element-11" />
    </div>;
}